<template lang="pug">
section
  s-page-title(title='Клиенты')
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onShow(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Клиент') {{ props.item.full_name }}
          td(data-label='Телефон') {{ props.item.phone | phone }}
          td(data-label='Дата рождения') {{ props.item.birthday | date }}
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      { text: '#ID', align: 'left', value: 'id', width: '0%' },
      {
        text: 'Клиент',
        align: 'left',
        value: 'second_name',
        width: '50%'
      },
      {
        text: 'Телефон',
        align: 'left',
        value: 'phone',
        width: '25%'
      },
      {
        text: 'Дата рождения',
        align: 'left',
        value: 'birthday',
        width: '25%'
      }
    ]
  }),

  methods: {
    onShow(id) {
      this.$router.push({
        name: 'Manager.Clients.Show',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('manager/clients', ['fetchList']),
    ...mapMutations('manager/clients', ['setDataFilter'])
  },

  computed: {
    ...mapState('manager/clients', ['total', 'dataFilter']),
    ...mapGetters('manager/clients', ['list', 'isLoading'])
  }
}
</script>
